import { MdOutlineDashboard, MdOutlineSell } from "react-icons/md";
import { BsBorderStyle } from "react-icons/bs";

export const accountingMenu = [
  {
    name: "داشبورد",
    path: "/dashboard/accounting/dashboard",
    icon: <MdOutlineDashboard size={20} />,
    type: "menu",
    child: ["/dashboard/accounting/dashboard"],
  },
  {
    name: "اطلاعات پایه",
    path: "/dashboard/accounting/baseInfo",
    icon: <MdOutlineSell size={20} />,
    type: "menu",
    child: [
      "/dashboard/accounting/baseInfo",
      "/dashboard/accounting/baseInfo/personInfo",
      "/dashboard/accounting/baseInfo/cach-desk",
      "/dashboard/accounting/baseInfo/banks",
      "/dashboard/accounting/baseInfo/checks",
      "/dashboard/accounting/baseInfo/addAnbar",
      "/dashboard/accounting/baseInfo/income",
      "/dashboard/accounting/baseInfo/costs",
    ],
  },
  {
    name: "عملیات",
    path: "/dashboard/accounting/orders",
    icon: <BsBorderStyle size={20} />,
    type: "submenu",
    child: [
      "/dashboard/accounting/orders",
      "/dashboard/accounting/orders/invoice",
      "/dashboard/accounting/orders/sales-invoice",
      "/dashboard/accounting/orders/factors",
      "/dashboard/accounting/orders/list-factor",
      "/dashboard/accounting/orders/get-operation-list",
      "/dashboard/accounting/orders/list-purchase-invoice",
      "/dashboard/accounting/orders/list-payment-operation",
      "/dashboard/accounting/orders/return-sales",
    ],
  },
  {
    name: "سفارش های سایت",
    path: "/dashboard/accounting/siteOrders",
    icon: <MdOutlineSell size={20} />,
    type: "menu",
    child: ["/dashboard/accounting/siteOrders"],
  },
  {
    name: "گزارشات",
    path: "/dashboard/accounting/reports",
    icon: <MdOutlineSell size={20} />,
    type: "menu",
    child: [
      "/dashboard/accounting/reports",
      "/dashboard/accounting/reports/cash-desk",
      "/dashboard/accounting/reports/banks",
      "/dashboard/accounting/reports/checksReceived",
      "/dashboard/accounting/reports/checksPaid",
      "/dashboard/accounting/reports/income",
      "/dashboard/accounting/reports/costs",
    ],
  },
];

export const personalInfo = [
  {
    id: "0",
    label: "همه",
    value: "",
  },
  {
    id: "1",
    label: "سرنخ",
    value: "member",
  },
  {
    id: "2",
    label: "ادمین",
    value: "admin",
  },
  {
    id: "3",
    label: "مشتری",
    value: "behsod",
  },
  {
    id: "4",
    label: "منشی",
    value: "clerk",
  },
  {
    id: "5",
    label: "تامیین کننده",
    value: "Supplier",
  },
  {
    id: "6",
    label: "بازاریاب",
    value: "Marketer",
  },
  {
    id: "7",
    label: "متفرقه",
    value: "NotApproved",
  },
];
